import { useState } from "react";
import { FetchResult, gql, useMutation } from "@apollo/client";
import { useToast } from "@/hooks/use-toast";

const IMPORT_CONTACTS_QUERY = gql`
  mutation ImportContact($contactList: [ContactDTOInput]) {
    importContacts(contactList: $contactList)
  }
`;

interface uploadDocumentsQueryVariables {
  contactList: Record<string, string>;
}

interface uploadDocumentsQueryResponse {
  importContacts: Record<string, string>[];
}

export const useImportContacts = () => {
  const [submitting, setSubmitting] = useState(false);
  const { toast } = useToast();
  const [handleUploadDocument] = useMutation<
    uploadDocumentsQueryResponse,
    uploadDocumentsQueryVariables
  >(IMPORT_CONTACTS_QUERY);

  const importContacts = async (
    contactList: Record<string, string>,
    callback?: () => void
  ) => {
    setSubmitting(true);
    try {
      const apiResponse = await handleUploadDocument({
        variables: { contactList },
      });
      handleBadAPIResponse(apiResponse);
      setSubmitting(false);
      callback && callback();
      return apiResponse;
    } catch (e: unknown) {
      console.log(e);
      toast({
        title: "Error importing contacts",
        description: "An error occurred while importing contacts",
        variant: "destructive",
        duration: 3000,
      });
      setSubmitting(false);
      return null;
    }
  };

  return { importContacts, submitting };
};

//***:cqcsContactNotes=2024-12-16=testingTesting2

const handleBadAPIResponse = (
  apiResponse: FetchResult<
    uploadDocumentsQueryResponse,
    Record<string, unknown>,
    Record<string, unknown>
  >
) => {
  if (!apiResponse.data || !apiResponse.data.importContacts) {
    throw new Error("Error importing contacts");
  }
};
